import React from 'react';
import { LISTING_HEAP_PAGE_AREA_IDS } from '../../constants';
import { ReportThisEventButton } from '../ReportThisEvent/ReportThisEventButton';
import {
    DescriptiveOrganizerInfo,
    DescriptiveOrganizerInfoProps,
} from '../_shared/OrganizerInfo/DescriptiveOrganizerInfo';
import './OrganizerPanel.scss';

export type OrganizerPanelLayoutProps = {
    shouldShowMoreEventsFromThisOrganizer?: boolean;
    isSalesEndedListingExperimentEnabled?: boolean;
};

export const OrganizerPanelLayout = ({
    shouldShowMoreEventsFromThisOrganizer,
    captchaKey,
    eventName,
    gaCategory,
    isAuthenticated,
    organizerAvatar,
    organizerDescription,
    organizerId,
    organizerName,
    organizerUrl,
    organizerFacebook,
    organizerTwitter,
    organizerWebsite,
    isSalesEndedListingExperimentEnabled,
}: OrganizerPanelLayoutProps & DescriptiveOrganizerInfoProps) => {
    return (
        <section className="listing-organizer eds-l-pad-bot-5">
            <DescriptiveOrganizerInfo
                captchaKey={captchaKey}
                organizerAvatar={organizerAvatar}
                organizerDescription={organizerDescription}
                organizerId={organizerId}
                organizerName={organizerName}
                organizerUrl={organizerUrl}
                organizerFacebook={organizerFacebook}
                organizerTwitter={organizerTwitter}
                organizerWebsite={organizerWebsite}
                isAuthenticated={isAuthenticated}
                eventName={eventName}
                gaCategory={gaCategory}
                pageArea={LISTING_HEAP_PAGE_AREA_IDS.ORGANIZER_PANEL}
            />
            <div className="eds-align--center eds-l-mar-bot-3">
                <ReportThisEventButton />
            </div>
            {shouldShowMoreEventsFromThisOrganizer &&
                !isSalesEndedListingExperimentEnabled && (
                    <div id="listings-root__more-events-from-this-organizer"></div>
                )}
            {!isSalesEndedListingExperimentEnabled && (
                <div id="listings-root__collections-related-to-this-event"></div>
            )}
        </section>
    );
};
